import "./css/happy_students_collaborated_with.css";

const HappyStudentsCollaboratedWith = ({
  images,
  heading,
  message,
  number,
}) => {
  return (
    <div className="happy_students_collaboration">
      <h3>{heading}</h3>
      <div className="images_and_message">
        <span className="images">
          {images.map((image_url, index) => (
            <img key={index} src={image_url} alt={index} />
          ))}
          {number === 0 ? (
            <span className="dummy_plus">+</span>
          ) : (
            <span className="dummy_plus smaller_text">+{number}</span>
          )}
        </span>
        <span className="message">{message}</span>
      </div>
    </div>
  );
};

export default HappyStudentsCollaboratedWith;
